module.exports = __webpack_public_path__ + "img/portraits_08_V.63369546.jpg";